import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    IconButton,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow
} from "@material-ui/core";
import ExportsToolbar from "./ExportsToolbar";
import {connect} from "react-redux";
import {loadLatestInstance} from "../../../actions";
import {
    EXPORT_DELETE, EXPORT_DIALOG_CLOSE,
    EXPORT_DOWNLOAD, EXPORT_GENERATE,
    EXPORT_LOAD_LIST,
    SET_EXPORT_PAGE_PAGINATION
} from "../../../reducers/exportEntries/exportEntriesActions";
import {DownloadIcon} from "../../../util/Util";
import TablePaginationActions from "../../PlayersList/TablePaginationActions";
import {withTranslation} from "react-i18next";
import ExportDialog from "./ExportDialog";
import {DeleteForever} from "@material-ui/icons";

const styles = (theme) => ({
    root: {
        width: '100%'
    },
    table: {
        minWidth: 1020,
        width: '100%'
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto'
    }
});

class ExportsPage extends Component {

    handleChangePage = (event, page) => {
        this.props.setPagination(page, null);
    };

    handleChangeRowsPerPage = (event) => {
        this.props.setPagination(null, event.target.value);
    };

    handleInstanceSelect = (event) => {
        this.props.loadExports(event.target.value);
    };

    startDownloadHandler = (exportId) => {
        this.props.downloadExport(exportId);
    };

    deleteExportHandler = (exportId) => {
        this.props.deleteExport(exportId, this.props.currentInstance.id);
    };

    generateExportHandler = () => {
        this.props.generateExport(this.props.currentInstance.id);
    };

    refreshExportsHandler = () => {
        this.props.loadExports(this.props.currentInstance.id);
    };

    dialogCloseButtonHandler = () => {
        this.props.closeDialog();
    };

    componentDidMount() {
        if (!this.props.currentInstance) {
            // TODO this should actually load both the instance and also the current exports for that instance
            this.props.loadLatestInstance();
        } else {
            this.props.loadExports(this.props.currentInstance.id);
        }
    }

    render() {
        const {classes, dialogOpen, entryExports, loading, page, rowsPerPage, status, t} = this.props;
        const {exportData, error} = this.props;

        const pageData = entryExports.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
        const emptyRows = rowsPerPage - pageData.length;

        const progress = loading ? <LinearProgress /> : null;

        const items = pageData.map((item) => {
            const parsedTimestamp = Date.parse(item.generatedDate);
            const parsedDate = new Date(parsedTimestamp);
            const displayDate = parsedDate.toLocaleDateString() + " " + parsedDate.toLocaleTimeString();

            return (
                <TableRow key={item.id}>
                    <TableCell>
                        {displayDate}
                    </TableCell>
                    <TableCell>
                        {item.length}
                    </TableCell>
                    <TableCell>
                        <IconButton aria-label="download-export" onClick={() => this.startDownloadHandler(item.id)}>
                            <DownloadIcon />
                        </IconButton>
                        <IconButton aria-label="download-export" onClick={() => this.deleteExportHandler(item.id)}>
                            <DeleteForever />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });

        return (
            <Paper className={classes.root}>
                <ExportsToolbar
                    title="Exports"
                    handleGenerateButtonClick={() => this.generateExportHandler()}
                    handleRefreshButtonClick={() => this.refreshExportsHandler()}
                />
                {progress}
                <div className={classes.tableWrapper}>
                    <Table  className={classes.table} aria-labelledby="tableTitle">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" padding="default">
                                    Generated Date
                                </TableCell>
                                <TableCell align="left" padding="default">
                                    Size
                                </TableCell>
                                <TableCell align="left" padding="default">
                                    &nbsp;
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items}
                            {emptyRows > 0 && (
                                <TableRow style={{height: 49 * emptyRows}}>
                                    <TableCell colSpan={3} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={entryExports.length}
                    page={page}
                    onChangePage={(e, p) => this.handleChangePage(e, p)}
                    onChangeRowsPerPage={(e) => this.handleChangeRowsPerPage(e)}
                    rowsPerPage={rowsPerPage}
                    labelRowsPerPage={t('playersList.rowsPerPage')}
                    ActionsComponent={TablePaginationActions}
                />
                <ExportDialog
                    open={dialogOpen}
                    loading={loading}
                    status={status}
                    exportData={exportData}
                    error={error}
                    handleClose={() => this.dialogCloseButtonHandler()}
                />
            </Paper>
        );
    }
}

const mapStateToProps = (state) => {
    const rowsPerPage = state.exportEntries.rowsPerPage;
    const entryExports = state.exportEntries.exports;
    return {
        currentInstance: state.root.currentInstance,
        rowsPerPage: rowsPerPage,
        page: state.exportEntries.page,
        entryExports: entryExports,
        dialogOpen: state.exportEntries.dialogOpen,
        loading: state.exportEntries.loading,
        status: state.exportEntries.status,
        exportData: state.exportEntries.exportData,
        error: state.exportEntries.err
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadLatestInstance: () => dispatch(loadLatestInstance('Czech Open')),
        setPagination: (page, rowsPerPage) => dispatch({type: SET_EXPORT_PAGE_PAGINATION, page: page, rowsPerPage: rowsPerPage}),
        loadExports: (instanceId) => dispatch({type: EXPORT_LOAD_LIST, instanceId: instanceId}),
        downloadExport: (exportId) => dispatch({type: EXPORT_DOWNLOAD, exportId: exportId}),
        generateExport: (instanceId) => dispatch({type: EXPORT_GENERATE, instanceId: instanceId}),
        deleteExport:  (exportId, instanceId) => dispatch({type: EXPORT_DELETE, exportId: exportId, instanceId: instanceId}),
        closeDialog: () => dispatch({type: EXPORT_DIALOG_CLOSE}),
    };
};

export default withTranslation('messages')(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ExportsPage)));